type TProps = {
  className?: string;
};

export const ArrowLeftIcon = ({ className }: TProps) => {
  return (
    <svg fill="none" height="21" width="21" xmlns="http://www.w3.org/2000/svg">
      <path
        className={className}
        clipRule="evenodd"
        d="m6.042 11.585 5.244 5.244-1.178 1.179-7.256-7.256 7.255-7.256 1.179 1.179-5.244 5.244h12.155v1.666H6.042z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};
